import {LayerContainer} from "features/apartmentViewer/ApartmentViewer/containers/LayerContainer";
import {ShaderMaterial, Vector4} from "three";
import {TimeService} from "features/apartmentViewer/ApartmentViewer/services/TimeService";

export class LayerManager {
    constructor(
        private timeService: TimeService
    ) {}

    updateActiveLayers(layerData: LayerContainer): number {
        let activeLayerIndex = 0;
        for (const layer of layerData.layers) {
            if (layer.isActive) {
                layer.update();
                activeLayerIndex++;
            }
        }
        return activeLayerIndex;
    }

    updateMaterialUniforms(material: ShaderMaterial, activeLayers: LayerContainer, activeLayerIndex: number): void {
        for (let i = 0; i < activeLayerIndex; i++) {
            const layer = activeLayers.layers[i];
            material.uniforms.layerTextures.value[i] = layer.renderTexture.texture;
            material.uniforms.layerInfo.value[i] = new Vector4(
                layer.renderTexture.width,
                layer.renderTexture.height,
                layer.type,
                layer.alpha
            );
        }
        material.uniforms.time.value = this.timeService.time; // Replace with TimeService
    }
}
